'use es6';

import { createSelector } from 'reselect';
import { getHasDecoupledHeadersAndFootersAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { calculateHoverPositions, calculateHoverPositionsForGridLayouts, calculateHoverPositionsForDecoupledHeadersAndFooters } from 'InpageEditorUI/lib/layoutSection/hoverPositionCalculator';
export const getCalculateHoverPositionsCalculator = createSelector([getHasDecoupledHeadersAndFootersAccess, getIsEditingGridLayouts], (hasDecoupledHeadersAndFootersAccess, isEditingGridLayouts) => {
  if (isEditingGridLayouts) {
    return calculateHoverPositionsForGridLayouts;
  }
  if (hasDecoupledHeadersAndFootersAccess) {
    return calculateHoverPositionsForDecoupledHeadersAndFooters;
  }
  return calculateHoverPositions;
});